import React from 'react';
import {sortTable} from "../../constant";
import {BiSort} from "react-icons/bi";
import {CFormCheck, CImage} from "@coreui/react-pro";
import FailIcon from "../../assets/icons/assessment-fail-icon.png";
import PassIcon from "../../assets/icons/assessment-pass-icon.png";
import Table from "../tables/table";
import {FaEdit, FaTrashAlt} from "react-icons/fa";
import avatarUrl from "../../assets/images/attendanceProfile.png";


function AttendanceProfile({profileTab, setProfTap, profTap, detail, userType}) {
    return (
        <div className="bg-white py-4 h-100 rounded-2" style={{maxWidth: '270px'}}>

            <div className="w-100 d-flex flex-column px-2 align-items-center">
                <CImage src={avatarUrl} className="rounded-2"
                        style={{width: '70px', height: '70px'}}/>
                <div className="fw-bolder text-3 p-0 m-0">Chukwudi Obed Ayuba</div>
                <small>Front End Development</small>
                <small className="bg-grey px-4 py-1">{userType}</small>
            </div>
            <br/>
            <br/>
            {profileTab?.map((item, index) => {
                return (
                    <div key={index}
                         onClick={() => {
                             setProfTap(index);
                         }}
                         className={`${profTap == index ? "bg-primary text-white" : "text-black-50"} border border-start-0 border-end-0 border-top-0  px-4 py-3 gap-2 d-flex align-items-center cursor-pointer`}>
                        {item?.icon} <small>{item?.title}</small>
                    </div>

                )
            })}
            <div
                onClick={() => {
                }}
                className="text-danger  border border-start-0 border-end-0 border-top-0 border-danger px-4 py-3 gap-2 d-flex align-items-center cursor-pointer">
                <FaTrashAlt/> <small>Remove Trainer</small>
            </div>
        </div>
    );
}

export default AttendanceProfile;
